<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!--<div class="list-row">-->
  <v-row class="list-row" @click="$store.commit('dialog_is_product',{toggle:true,index:currentIndex})">
    <v-col class="col-1 col border">

    </v-col>
    <v-col class="border">
      {{ (item.product?item.product.nickname:null) || item.product_code}}
    </v-col>
    <v-col class="col-2 border text-right">
      {{ item.price_in_vat}}
    </v-col>
    <v-col class="col-2 border text-right">
      {{item.discount_internal_amount}}
    </v-col>
    <v-col class="col-2 border text-right">
      {{ item.price_in_vat-item.discount_internal_amount/item.quantity}}
    </v-col>
    <v-col class="col-1 border text-right">
      {{ item.quantity}}
    </v-col>
    <v-col class="col-2 border text-right">
      {{ item.total_gross}}
    </v-col>
  </v-row>
  <!--</div>-->

</template>
<style lang="scss" scoped>

  .border {
    border: solid 1px #FFFFFF;
  }

  .list-row {
    padding: 0;
  }

</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {Item} from '../../models/Item'

  @Component({
    components: {},
  })
  export default class ItemRow extends Vue {
    @Prop() item: Item
    @Prop() currentIndex: number

  }

</script>
